var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grow } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
export function Skill(_a) {
    var src = _a.src, id = _a.id, customer = _a.customer, params = _a.params, preview = _a.preview, from = _a.from, generateToken = _a.token, tokenParam = _a.tokenParam;
    var _b = useState(0), height = _b[0], setHeight = _b[1];
    var _c = useState(''), token = _c[0], setToken = _c[1];
    var _d = useState(''), contactId = _d[0], setContactId = _d[1];
    useEffect(function () {
        var f = function (_a) {
            var data = _a.data;
            if (data.__krkr__ && data._id === id && data.type === 'resize') {
                // console.log(data)
                setHeight(data.height);
            }
        };
        window.addEventListener('message', f);
        return function () {
            window.removeEventListener('message', f);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        function init() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, contactId, token;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, generateToken(src.replace(/^.*?\/skills\/([^\]/?]+).*?$/, '$1'), tokenParam)];
                        case 1:
                            _a = _b.sent(), contactId = _a.id, token = _a.token;
                            setToken(token);
                            setContactId(contactId);
                            return [2 /*return*/];
                    }
                });
            });
        }
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    var $skill = useRef(null);
    var handleSkillLoad = function () {
        var _a, _b;
        (_b = (_a = $skill === null || $skill === void 0 ? void 0 : $skill.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage({
            type: 'init',
            _id: id,
            // next: data.skill.next,
            customer: customer,
            params: params,
            skillParams: {
                id: contactId,
                token: token,
                from: from,
                preview: preview,
            },
        }, '*');
    };
    var skillStyle = { display: 'block', border: 'none', width: '100%', height: height };
    if (!token) {
        return null;
    }
    return (_jsx(Grow, { in: true, timeout: 1000, children: _jsx("iframe", { src: src, style: skillStyle, onLoad: handleSkillLoad, ref: $skill, scrolling: "no" }) }));
}
//# sourceMappingURL=Skill.js.map